import * as React from 'react'
import { useTranslation } from 'react-i18next'
import {
  AppButton,
  FlexBox,
  FullLayout,
  PaddingContainer,
  PageHeading,
  SharedIcon,
} from 'shared'
import { CustomerTokens } from '../../../typedef/customer'
import Translations from '../../../utils/translations'

interface RegistrationCompleteProps {
  customer?: CustomerTokens
  onClick: () => void
}

const RegistrationComplete: React.FunctionComponent<RegistrationCompleteProps> = props => {
  const { t } = useTranslation()

  return (
    <FullLayout imageBackground hasTopBar>
      <PaddingContainer>
        <PageHeading
          title={t(Translations.WELCOME)}
          subtitle={t(Translations.YOUR_ACCOUNT_HAS_BEEN_SUCCESFULLY_CREATED)}
        >
          <SharedIcon.Ok />
        </PageHeading>
        <FlexBox hasTopMargin>
          <AppButton variant="outlined" onClick={props.onClick}>
            {t(Translations.OK)}
          </AppButton>
        </FlexBox>
      </PaddingContainer>
    </FullLayout>
  )
}

export default RegistrationComplete
